export default "__VITE_ASSET__BUF8KUEk__"